import createParamRewriterComponent from '../utils/create-param-rewriter'

export default createParamRewriterComponent('ae-design-selector')
